import { IssueTypeOption, SupportForEvDriversWeb2CaseFormValues } from './SupportForEvDriversWeb2CaseForm.schema';

export const ISSUE_TYPE_OPTIONS: IssueTypeOption[] = [
  {
    label: 'Ladevorgänge / Lastmanagement',
    value: 'Charging sessions / Load management',
  },
  {
    label: 'Hardware Defekt / Fehlermeldung',
    value: 'Hardware defect / Error message',
  },
  {
    label: 'Etwas anderes',
    value: 'Something else',
  },
];

export const INITIAL_VALUES: SupportForEvDriversWeb2CaseFormValues = {
  who: 'Ich bin E-Fahrer:in',
  first_name: '',
  last_name: '',
  postal_code: '',
  street: '',
  city: '',
  phone: '',
  email: '',
  issue_type: undefined,
  'g-recaptcha-response': '',
};
